import { render, staticRenderFns } from "./BatchSend.vue?vue&type=template&id=5303b560&scoped=true&"
import script from "./BatchSend.vue?vue&type=script&lang=js&"
export * from "./BatchSend.vue?vue&type=script&lang=js&"
import style0 from "./BatchSend.vue?vue&type=style&index=0&id=5303b560&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5303b560",
  null
  
)

export default component.exports